import React, { useState, useEffect } from 'react'
import ReactExport from 'react-export-excel'
import Icon from '@mdi/react'
import { getLastTrackingStatus, momentDate, momentDateDT, ReadableString } from '../../utils/Functions'
import moment from 'moment'
import { mdiFileDownloadOutline } from '@mdi/js'

const ExcelFile = ReactExport.ExcelFile
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn

const Metrics = (props) => {
	const { orderLimits, orders, segment } = props
	const [SheetData, setSheetData] = useState([])

	const OrderTypes = {
		Import: {
			headers: [
				{ key: 'biltyNumber', title: 'Bilty Number' },
				{ key: 'orderNumber', title: 'Order Number' },
				{ key: 'orderType', title: 'Order Type' },
				{ key: 'documentNumber', title: 'BL Number' },
				{ key: 'clientName', title: 'Business Name' },
				{ key: 'loadingDate', title: 'Loading Date' },
				{ key: 'dropoff', title: 'Drop Off' },
				{ key: 'invoicing', title: 'Invoice Number' },
				{ key: 'containerNumber', title: 'Container Number' },
				{ key: 'driverPhone', title: 'Driver Phone' },
				{ key: 'driverVehicleRegistration', title: 'Vehicle Number' },
				{ key: 'driverName', title: 'Driver Name' },
				{ key: 'brokerName', title: 'Broker Name' },
				{ key: 'supplierName', title: 'Supplier Name' },
				{ key: 'assignedAt', title: 'Driver Assigned At' },
				{ key: 'assignmentDays', title: 'Days Since Assignment' },
				{ key: 'lastStatus', title: 'Last Status' },
				{ key: 'lastSubStatus', title: 'Last Sub Status' },
				{ key: 'biltyCreatedAt', title: 'Bilty Created At' },
				{ key: 'biltyCreatedBy', title: 'Bilty Created By' },
				{ key: 'biltyCompletedAt', title: 'Bilty Completed At' },
				{ key: 'biltyCompletedBy', title: 'Bilty Completed By' },
				{ key: 'biltyStatus', title: 'Bilty Status' },
			],
			initial: 'I',
		},
		Export: {
			headers: [
				{ key: 'biltyNumber', title: 'Bilty Number' },
				{ key: 'orderNumber', title: 'Order Number' },
				{ key: 'documentNumber', title: 'CRO Number' },
				{ key: 'clientName', title: 'Business Name' },
				{ key: 'loadingDate', title: 'Loading Date' },
				{ key: 'dropoff', title: 'Drop Off' },
				// { key: 'unloadingDate', title: 'Unloading Date' },
				{ key: 'invoicing', title: 'Invoice Number' },
				{ key: 'containerNumber', title: 'Container Number' },
				{ key: 'driverPhone', title: 'Driver Phone' },
				{ key: 'driverVehicleRegistration', title: 'Vehicle Number' },
				{ key: 'driverName', title: 'Driver Name' },
				{ key: 'brokerName', title: 'Broker Name' },
				{ key: 'supplierName', title: 'Supplier Name' },
				{ key: 'assignedAt', title: 'Driver Assigned At' },
				{ key: 'assignmentDays', title: 'Days Since Assignment' },
				{ key: 'lastStatus', title: 'Last Status' },
				{ key: 'lastSubStatus', title: 'Last Sub Status' },
				{ key: 'biltyCreatedAt', title: 'Bilty Created At' },
				{ key: 'biltyCreatedBy', title: 'Bilty Created By' },
				{ key: 'biltyCompletedAt', title: 'Bilty Completed At' },
				{ key: 'biltyCompletedBy', title: 'Bilty Completed By' },
				{ key: 'biltyStatus', title: 'Bilty Status' },
			],
			initial: 'E',
		},
		LongHaul: {
			headers: [
				{ key: 'biltyNumber', title: 'Bilty Number' },
				{ key: 'orderNumber', title: 'Order Number' },
				{ key: 'clientName', title: 'Business Name' },
				{ key: 'invoicing', title: 'Invoice Number' },
				{ key: 'driverPhone', title: 'Driver Phone' },
				{ key: 'driverVehicleRegistration', title: 'Vehicle Number' },
				{ key: 'driverName', title: 'Driver Name' },
				{ key: 'brokerName', title: 'Broker Name' },
				{ key: 'supplierName', title: 'Supplier Name' },
				{ key: 'assignedAt', title: 'Driver Assigned At' },
				{ key: 'assignmentDays', title: 'Days Since Assignment' },
				{ key: 'lastStatus', title: 'Last Status' },
				{ key: 'dropoff', title: 'Drop Off' },
				{ key: 'lastSubStatus', title: 'Last Sub Status' },
				{ key: 'biltyCreatedAt', title: 'Bilty Created At' },
				{ key: 'biltyCreatedBy', title: 'Bilty Created By' },
				{ key: 'biltyCompletedAt', title: 'Bilty Completed At' },
				{ key: 'biltyCompletedBy', title: 'Bilty Completed By' },
				{ key: 'biltyStatus', title: 'Bilty Status' },
			],
			initial: 'L',
		},
	}

	useEffect(() => {
		getOrders()
	}, [orders]) // eslint-disable-line

	const getOrders = () => {
		let OrdersData = []
		orders &&
			orders?.length > 0 &&
			orders.forEach((order) => {
				let RowData = {}
				const statusHistories = []
				const biltyCreatedAt = order?.bilty?.biltyCreatedAt
				const biltyCreatedBy = order?.biltyCreatedByName
				const biltyCompletedBy = order?.bilty?.biltyCompletedByName
				const biltyCompletedAt = order?.biltyCompletedAt
				const dropoff = order?.journeyLocations?.dropoff?.map((location, index) =>
					order?.journeyLocations?.dropoff?.length > 1 ? `${index}. ${location?.Location?.formattedAddress}` : location?.Location?.formattedAddress
				)
				const subOrderNumber = order?.subOrderNumber
				const containerNumber = order?.containerNumber
				const businessName = order?.businessName
				const driverDetails = order?.Driver
				const brokerDetails = order?.Broker
				const supplierDetails = order?.Supplier
				const documentNumber = order?.documentNumber
				const invoiceNumber = order?.invoiceNumber
				const driverAssignedAt = order?.driverAssignedAt ? moment(order?.driverAssignedAt)?.format('MM/DD/yyyy HH:mm A') : null
				const loadingDT = order?.loadingDT
				const journeys = order?.Journeys
				const reverseJourneys = journeys?.slice()?.sort((a, b) => b?.steps - a?.steps)
				for (let i = 0; i < reverseJourneys?.length; i++) {
					const journey = reverseJourneys?.[i]
					for (let j = 0; j < journey?.DriverStatusHistories?.length; j++) {
						const statusHistory = journey?.DriverStatusHistories?.[j]
						statusHistories?.push({ ...statusHistory })
					}
				}
				const lastDriverStatusHistory = statusHistories[statusHistories?.length - 1]
				const lastDriverStatus = lastDriverStatusHistory?.status
				const lastDriverSubStatus = getLastTrackingStatus(lastDriverStatusHistory)

				const driverAssignmentDT = order?.driverAssignedAt ? moment(order?.driverAssignedAt)?.startOf('day') : null
				const current = moment().startOf('day')
				const assignmentDaysDifference = order?.driverAssignedAt ? -driverAssignmentDT?.diff(current, 'days') : null
				RowData.clientName =
					businessName?.length <= 1 ? businessName?.join(' \n') : businessName?.map((value, index) => index + 1 + '. ' + value)?.join(' \n')
				RowData.containerNumber =
					containerNumber?.length <= 1 ? containerNumber?.join(' \n') : containerNumber?.map((value, index) => index + 1 + '. ' + value)?.join(' \n')
				RowData.orderNumber =
					subOrderNumber?.length <= 1
						? subOrderNumber?.map((value) => value)?.join(' \n')
						: subOrderNumber?.map((value, index) => index + 1 + '. ' + value)?.join(' \n')
				RowData.documentNumber =
					documentNumber?.length <= 1 ? documentNumber?.join(' \n') : documentNumber?.map((value, index) => index + 1 + '. ' + value)?.join(' \n')
				RowData.orderType =
					segment &&
					`${segment} ${
						order?.orderCategory?.length > 0 && order?.orderCategory?.some((value) => ['Shifting', 'Destuffing', 'DoubleTwenty']?.includes(value))
							? ` / ${order?.orderCategory?.[0]}`
							: ''
					}`
				RowData.invoicing =
					invoiceNumber?.length <= 1
						? invoiceNumber?.[0]
							? invoiceNumber?.join(' \n')
							: ''
						: invoiceNumber?.map((value, index) => (value ? index + 1 + '. ' + value : ''))?.join(' \n')
				RowData.dropoff = dropoff?.join(' \n')
				RowData.driverVehicleRegistration = order?.driverVehicleRegistration.toLowerCase() || ''
				RowData.driverPhone = driverDetails?.phoneNumber
				RowData.driverName = driverDetails && driverDetails?.name
				RowData.brokerName = brokerDetails && brokerDetails?.firstName + ' ' + brokerDetails?.lastName
				RowData.supplierName = supplierDetails && supplierDetails?.firstName + ' ' + supplierDetails?.lastName
				RowData.biltyNumber = order?.bilty?.biltyNumber
				RowData.assignedAt = driverAssignedAt
				RowData.assignmentDays = assignmentDaysDifference !== 0 ? assignmentDaysDifference : ''
				RowData.biltyCreatedAt = /^[0-9]+$/?.test(biltyCreatedAt)
					? momentDate(biltyCreatedAt, 'DD-MMM-YY HH:mm A')
					: momentDateDT(biltyCreatedAt, 'DD-MMM-YY HH:mm A')
				RowData.biltyCompletedAt = /^[0-9]+$/?.test(biltyCompletedAt)
					? momentDate(biltyCompletedAt, 'DD-MMM-YY HH:mm A')
					: momentDateDT(biltyCompletedAt, 'DD-MMM-YY HH:mm A')
				RowData.biltyCreatedBy = biltyCreatedBy ? biltyCreatedBy?.firstName + ' ' + biltyCreatedBy?.lastName : ''
				RowData.biltyCompletedBy = biltyCompletedBy ? biltyCompletedBy?.firstName + ' ' + biltyCompletedBy?.lastName : ''
				RowData.biltyStatus = order?.bilty?.biltyStatus ? order?.bilty?.biltyStatus : 'notReceived'
				RowData.loadingDate =
					loadingDT?.length <= 1
						? loadingDT?.map((value) => moment(value)?.format('MM/DD/yyyy HH:mm A'))?.join(' \n')
						: loadingDT?.map((value, index) => index + 1 + '. ' + moment(value)?.format('MM/DD/yyyy HH:mm A'))?.join(' \n')

				// RowData.unloadingDate = order?.unloadingCompletedTS ? momentDate(order?.unloadingCompletedTS, 'MM-DD-YYYY HH:mm A') : '' // remaining
				RowData.lastStatus = ReadableString(lastDriverStatus)
				RowData.lastSubStatus = lastDriverSubStatus?.status || lastDriverSubStatus?.formattedAddress

				OrdersData.push(RowData)
			})
		setSheetData(OrdersData)
	}

	return (
		<>
			{orderLimits && (
				<ExcelFile
					element={
						orderLimits && (
							<button className='flex flex-row border bg-white text-secondary-400 px-4 rounded-md items-center text-sm h-[40px] ml-4'>
								<Icon className='text-primary-800' path={mdiFileDownloadOutline} size={1} />
								<span className='pl-1  w-full text-center font-[600] text-primary-800 text-xs'>Download Metrics</span>
							</button>
						)
					}
				>
					<ExcelSheet data={SheetData} name={'Sheet'}>
						{OrderTypes[segment]?.headers?.map((header, index) => (
							<ExcelColumn key={index} label={header.title} value={header.key} />
						))}
					</ExcelSheet>
				</ExcelFile>
			)}
		</>
	)
}

export default Metrics
